module.exports = __webpack_public_path__ + "1a70b0cb1533ce8506ae619e48826944.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/feature02.png?v33
// module id = 800
// module chunks = 3